import EssayBody from '../../components/common/EssayBody';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { articleService, IArticle } from '../../services/articleService';
import ArticleImage from '../../components/common/ArticleImage';
import ArticleShare from '../../components/common/ArticleShare';
import { authorName } from '../../components/editorial/StoryCard';

const ArticleDetailPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [article, setArticle] = useState<IArticle | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchArticle = async () => {
      try {
        if (!slug) return;
        const data = /^\d+$/.test(slug) ? await articleService.getById(slug) : await articleService.getBySlug(slug);
        if (active) setArticle(data);
      } catch { if (active) setArticle(null); }
      finally { if (active) setLoading(false); }
    };
    fetchArticle();
    return () => { active = false; };
  }, [slug]);
  if (loading) return <div className="editorial-shell editorial-empty" role="status">Loading the story…</div>;
  if (!article) return <div className="editorial-shell editorial-empty"><h1>Article not found.</h1><Link to="/articles" className="editorial-link">Browse the magazine ↗</Link></div>;
  const date = new Date(article.created_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  return <div className="article-page"><article className="article-layout">
    <header className="article-heading"><div className="eyebrow">{article.category} / Perspectives</div><h1>{article.title}</h1>{article.excerpt && <p className="article-deck">{article.excerpt}</p>}<div className="article-meta"><Link to={`/writer/${article.author_id}`}>By {authorName(article)}</Link><span>{date}</span><span>{article.reading_time || 1} min read</span></div></header>
    {article.imageUrl && <figure className="article-figure"><ArticleImage src={article.imageUrl} alt={article.title} /></figure>}
    <EssayBody content={article.content} />
    <ArticleShare key={article.id} article={article} />
  </article></div>;
};
export default ArticleDetailPage;
